import { render, staticRenderFns } from "./IconTextButton.vue?vue&type=template&id=f48a4f4e"
import script from "./IconTextButton.vue?vue&type=script&lang=js"
export * from "./IconTextButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports